import { Button } from "@/components/ui/button";
import { RefreshCcw } from "lucide-react";
import { cn } from "@/lib/utils";

interface ResetModeButtonProps {
  restartMode: () => void;
  className?: string;
}

export function ResetModeButton({
  restartMode,
  className,
}: ResetModeButtonProps) {
  return (
    <div className="relative">
      <Button
        onClick={restartMode}
        className={cn(
          "absolute w-10 h-10 rounded-full p-2 ml-auto bg-cyan-600 hover:bg-cyan-700",
          className
        )}
        aria-label="Reset Mode"
      >
        <RefreshCcw className={`h-5 w-5 text-white`} />
      </Button>
    </div>
  );
}
